<script setup>
import { inject } from 'vue'

const props = defineProps({
  bannerData:{
    required: true
  }
})
const storeFourUploadBaseUrl = inject('storeFourBaseUrl')
const getImageSrc = (image) => {
  return `${storeFourUploadBaseUrl}/filepond/category_banner/${image}`
}
const goToTarget=(target)=>{
  window.location.href = target;
}
</script>

<template>
  <div class="w-100 d-flex align-items-center justify-center image__banner" :style="{background: bannerData.color_code}" @click="goToTarget(bannerData.target_url)">
    <v-img  width="100%" height="100%" :src="getImageSrc(!$vuetify.display.smAndDown ? bannerData.image_desktop_path : bannerData.image_mobile_path)"/>
  </div>
</template>

<style  lang="scss">
.image__banner{
  height: 68px;
  @include media-breakpoint-down(md){
    height: 40px;
  }

  cursor: pointer;
}
</style>